import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  CreateLabourForecastInput,
  CreateLabourForecastMutation,
} from '@/gql/graphql';

const CREATE_LABOUR_FORECAST_MUTATION = graphql(`
  mutation CreateLabourForecast($input: CreateLabourForecastInput!) {
    createLabourForecast(input: $input) {
      id
    }
  }
`);

const useCreateLabourForecast = (
  projectId: string,
  options?: UseMutationOptions<
    CreateLabourForecastMutation,
    unknown,
    CreateLabourForecastInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(CREATE_LABOUR_FORECAST_MUTATION, { input });
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: projectKeys.labourForecasts(projectId),
      });
      void queryClient.invalidateQueries({
        queryKey: projectKeys.profitBreakdown(projectId),
      });
    },
    ...options,
  });
};

export default useCreateLabourForecast;
